import { render, staticRenderFns } from "./TabsNav.vue?vue&type=template&id=5d43861e&scoped=true"
import script from "./TabsNav.vue?vue&type=script&lang=js"
export * from "./TabsNav.vue?vue&type=script&lang=js"
import style0 from "./TabsNav.vue?vue&type=style&index=0&id=5d43861e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43861e",
  null
  
)

export default component.exports